/**
 * One scope checkbox row — README §6. Mandatory scopes are locked (checked,
 * disabled) since they can't be unticked; everything else toggles freely.
 */
import React, { useCallback } from "react";
import Checkbox from "../../theme/untitled/Checkbox/Checkbox";
import styles from "./ScopesCard.module.scss";

const ScopeRow = ({ name, definition, checked, onChange }) => {
  const handleChange = useCallback(
    (e) => onChange(name, e.target.checked),
    [onChange, name]
  );

  return (
    <li className={styles.scopeRow}>
      <Checkbox
        size="md"
        id={`scope-${name}`}
        checked={definition.mandatory ? true : checked}
        disabled={definition.mandatory}
        onChange={handleChange}
        label={definition.label}
        supportingText={definition.description}
      />
    </li>
  );
};

export default ScopeRow;
